import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGlobe} from "@fortawesome/free-solid-svg-icons";
import DropdownMenu from "../../common/dropdown/dropdown-menu";
import BurgerMenu from "../../common/burgermenu/burgermenu";
import "./nav-xsci.css";
import "./nav-xsci-responsive.css"
import Logo from "../../common/logo/logo";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";


const  NavXCSI = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(); // Use the translation hook

    const currentLanguage = i18n.language; // Get current language

    // useEffect(() => {
    //     // const currentLanguage = i18n.language; // Get current language
    //     console.log(currentLanguage)
    // }, [currentLanguage]);


    const handleClick = (path: string) => {
        if (location.pathname === path) {
            // If the current path is the same as the clicked path, reload the page
            window.location.reload();
        } else {
            // Otherwise, navigate to the new path
            navigate(path);
        }
    };

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    // const [mobileMenuClicked, setMobileMenuClicked] = useState(false);

    const toggleMobileMenuOpen = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    }
    return (
        <header className="navbar navbar-expand-lg fixed-top py-3 header">
            <Logo/>
            <div className="menu_icon_container" onClick={toggleMobileMenuOpen}>
                <BurgerMenu clicked={mobileMenuOpen}/>
            </div>
            <nav>

                {/*MID NAV */}
                <div className={`mid_nav_container ${mobileMenuOpen ? 'mid_nav_container_open' : ''}`}>
                    <a href="/about"
                          className="mid_nav_container_non_dropdown_links">{String(t('navigation.about'))}</a>
                    <DropdownMenu mobileMenuOpen={mobileMenuOpen}/>
                    <a href="/contact" className="mid_nav_container_non_dropdown_links">{String(t('navigation.contact'))}</a>

                </div>
            </nav>
            <div
                className={`right_nav ${mobileMenuOpen ? 'right_nav_open' : ''}`}
                onClick={() => i18n.changeLanguage(currentLanguage === 'en' ? 'fr' : 'en')}
            >
                <span>{currentLanguage === 'en' ? 'FR' : 'EN'}</span>
                <span><FontAwesomeIcon className="language_icon" icon={faGlobe} size="1x"/></span>
            </div>

        </header>
    );
}

export default NavXCSI;
